<div *ngIf="viewData$ | async as data">
  <!-- Mobile: full-bleed hero with back button overlaid -->
  <div class="mobile-hero-wrapper d-md-none">
    <img [src]="data.offer.ImageUrl | contentImage : '6'" alt="" class="mobile-hero-img" />
    <button class="back-btn back-btn-overlay" (click)="goBack()">
      <span class="material-icons">arrow_back_ios_new</span>
    </button>
  </div>

  <div class="container py-md-4">
    <!-- Desktop: back button in normal flow -->
    <button class="back-btn mb-4 d-none d-md-flex" (click)="goBack()">
      <span class="material-icons">arrow_back_ios_new</span>
    </button>

    <div class="row g-md-4">
      <!-- Desktop only: left col with hero image and accordion -->
      <div class="col-md-7 d-none d-md-block">
        <div class="offer-hero">
          <img [src]="data.offer.ImageUrl | contentImage : '6'" alt="" class="offer-hero-img" />
        </div>
        <ng-container *ngTemplateOutlet="accordionTpl"></ng-container>
      </div>

      <!-- Info card: full width on mobile, col-5 on desktop -->
      <div class="col-12 col-md-5 mb-2 mb-lg-0">
        <div class="offer-detail-card">
          <div class="d-flex flex-column gap-3">
            <div class="detail-logo-wrapper">
              <img
                [src]="data.company?.ImageUrl | contentImage : '6'"
                alt="{{ data.company?.DisplayName }}"
                class="detail-logo"
              />
            </div>
            <div>
              <p class="detail-company-name mb-1">{{ data.company?.DisplayName }}</p>
              <h3 class="detail-offer-title mb-0">{{ data.offer.Content[0]?.Name }}</h3>
            </div>
          </div>
          <button
            *ngIf="data.company?.WebsiteUrl"
            class="btn-go-to-offer w-100"
            (click)="claimOffer(data.offer.OfferId)"
          >
            Go to Offer
          </button>
        </div>
      </div>

      <!-- Mobile only: accordion below card -->
      <div class="col-12 d-md-none">
        <ng-container *ngTemplateOutlet="accordionTpl"></ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #accordionTpl>
  <div class="accordion-section" *ngIf="viewData$ | async as data">
    <div class="accordion-item" [class.border-0]="!data.offer.TermsAndConditions">
      <button class="accordion-header" (click)="descriptionOpen = !descriptionOpen">
        <span [class.fw-bold]="descriptionOpen">Description</span>
        <span class="material-icons">{{ descriptionOpen ? 'expand_less' : 'expand_more' }}</span>
      </button>
      <div class="accordion-body" *ngIf="descriptionOpen" [@slideDown]>
        <p class="mb-0">{{ data.offer.Content[0]?.Description }}</p>
      </div>
    </div>
    <div class="accordion-item border-0" *ngIf="data.offer.TermsAndConditions">
      <button class="accordion-header" (click)="tcsOpen = !tcsOpen">
        <span [class.fw-bold]="tcsOpen">T&amp;Cs</span>
        <span class="material-icons">{{ tcsOpen ? 'expand_less' : 'expand_more' }}</span>
      </button>
      <div class="accordion-body" *ngIf="tcsOpen" [@slideDown]>
        <p class="mb-0">{{ data.offer.TermsAndConditions }}</p>
      </div>
    </div>
  </div>
</ng-template>
